import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { IUser } from "../interfaces/ilogin";
import * as applicationUserActions from "../actions/applicationuser.action";
import { IKeyContact } from "../interfaces/ikeycontact";

const initialState: IUser = {
    id: null,
    userName: "",
    access_token: "",
    expires_in: 0,
    selectedBusinessFunction: { keyContacts: new Array<IKeyContact>() } as IBusinessFunction,
    businessFunctions: new Array<IBusinessFunction>(),
    firstName: "",
    lastName: "",
    email: "",
    roles: new Array<string>()
};

export function applicationUserReducer(state: IUser = initialState, action: applicationUserActions.Actions): IUser {
    switch (action.type) {
    case applicationUserActions.actionTypes.SET_USER_DETAILS:
        return (action as applicationUserActions.SetUserDetailsAction).payload;
    case applicationUserActions.actionTypes.SET_SELECTED_BUSINESS_FUNCTION:
        return {
            ...state,
            selectedBusinessFunction: (action as applicationUserActions.SetSelectedBusinessFunctionAction).payload
        };
    case applicationUserActions.actionTypes.ADD_BUSINESS_FUNCTION:
        const payload: IBusinessFunction = (action as applicationUserActions.AddBusinessFunctionAction).payload as IBusinessFunction;
        if (payload && payload.id) {
            return {
                ...state,
                businessFunctions: [...state.businessFunctions, payload]
            };
        }
        return state;
    case applicationUserActions.actionTypes.CLEAR_USER_DETAILS:
        return {
            ...state,
            id: "",
            userName: "",
            access_token: "",
            expires_in: 0,
            selectedBusinessFunction: {} as IBusinessFunction,
            businessFunctions: new Array<IBusinessFunction>(),
            firstName: "",
            lastName: "",
            email: "",
            roles: new Array<string>()
        };
    case applicationUserActions.actionTypes.CLEAR_SELECTED_BUSINESS_FUNCTION:
        return {
            ...state,
            selectedBusinessFunction: {} as IBusinessFunction
        };
    default:
        return state;
    }
}